






































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PayServiceModel } from '@/models/payservice';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class CustomerInfo extends Vue {
    @Prop({default: null})
    private payservice!: PayServiceModel;
    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }
}
